import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "invoice"
const InvoiceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m18 22-2-2-2 2-2-2-2 2-2-2-2 2-2-2V2.992A.994.994 0 0 1 5 2h14c.552 0 1 .455 1 .992V20l-2 2ZM7 15h10v-1H7v1Zm0 2h5v-1H7v1Zm5.971-6.896a.315.315 0 0 0 .025-.028L13 9.954l-.425-.564-.149-.008a2.195 2.195 0 0 1-.453.349c-.366.22-.778.352-1.227.352-.692 0-1.28-.325-1.641-.871h1.849l.097-.097v-.763l-.097-.097H8.758a2.42 2.42 0 0 1-.002-.571h2.198l.097-.097v-.764l-.097-.096H9.107c.355-.516.935-.818 1.632-.818.411 0 .795.111 1.14.295.208.111.356.221.432.292l.147-.017.393-.589-.01-.12-.029-.029.026-.04a2.434 2.434 0 0 0-.471-.318A3.369 3.369 0 0 0 10.762 5H10.706c-1.222 0-2.259.671-2.723 1.727h-.885L7 6.823v.764l.098.097h.642a3.05 3.05 0 0 0-.001.571h-.641L7 8.352v.763l.098.097h.871C8.425 10.307 9.463 11 10.723 11h.057c.646 0 1.212-.173 1.695-.461a2.76 2.76 0 0 0 .525-.395l-.029-.04Z"
      />
    </svg>
  )
}
export default InvoiceIcon
